// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","modal":"Modal_modal__DJDMv","appear":"Modal_appear__hbDJd","container":"Modal_container__Ha+Ky","icon":"Modal_icon__2UpwH"};